<template>
    <div class="mobileXpadding">
        <div v-if="!$attrs.mainevent || !sameday(JSON.parse($attrs.mainevent))"
            class="px-4 max-w-screen-xl mx-auto mb-6 flex justify-center flex-col-reverse md:flex-row dark:text-white mb-4 text-sm gap-2">
            <a :href="$attrs.mainevent ? '?eventsdate=' + today() + '&event=' + JSON.parse($attrs.mainevent).slug : '?eventsdate=' + today()"
                v-if="!isToday()"
                class="p-2 px-4 bg-gray-200 dark:bg-neutral-800 rounded-full flex justify-center gap-8 items-center w-full md:w-auto hover:scale-95 active:scale-90">
                {{ $t('Today') }}
            </a>
            <div
                class="p-2 bg-gray-200 dark:bg-neutral-800 rounded-full flex justify-between gap-4 items-center w-full md:w-auto  ">
                <a :href="$attrs.mainevent ? '?eventsdate=' + prevDay(date) + '&event=' + JSON.parse($attrs.mainevent).slug : '?eventsdate=' + prevDay(date)"
                    class="p-2 hover:bg-gray-300 dark:hover:bg-neutral-700 cursor-pointer dark:text-white rounded-full hover:bg-gray-300 dark:hover:bg-opacity-30">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill=currentColor
                        viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                    </svg>
                </a>
                <button @click="toggleDatepicker" class="hover:bg-gray-300 dark:hover:bg-opacity-30 px-6 py-2 rounded-2xl">
                    <div class="text-center font-medium">{{ getHeaderDate(date) }}</div>
                </button>
                <a :href="$attrs.mainevent ? '?eventsdate=' + nextDay(date) + '&event=' + JSON.parse($attrs.mainevent).slug : '?eventsdate=' + nextDay(date)"
                    class="p-2 hover:bg-gray-300 dark:hover:bg-neutral-700 cursor-pointer dark:text-white rounded-full hover:bg-gray-300 dark:hover:bg-opacity-30">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill=currentColor
                        viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                    </svg>
                </a>
            </div>
        </div>

        <div v-if="showDatepicker" class="fixed inset-0 bg-black/50 z-100" @click="closeDatepicker"></div>

        <div class="relative flex justify-center w-full mx-auto">
            <div class="absolute w-full max-w-[600px]">

                <HotelDatePicker class="timetabledatepicker" v-if="showDatepicker" :alwaysVisible="true"
                    ref="timetabledatepicker" :firstDayOfWeek="1" :startingDateValue="new Date(date)"
                    :i18n="'datepicker' in $i18n.messages[$i18n.locale] ? $i18n.messages[$i18n.locale]['datepicker'] : $i18n.messages[$i18n.fallbackLocale]['datepicker']"
                    :hoveringTooltip="false" :showSingleMonth="true" :singleDaySelection="true"
                    @dayClicked="handleDayClick">
                </HotelDatePicker>

            </div>
        </div>
        <template v-if="Object.keys(data).length">
            <div class="timelineBlock scrollbar-hide !sticky z-[5] pointer-events-none"
                :class="[$attrs.iframe ? 'top-0' : 'top-[70px] md:top-[80px]']">
                <div class="timeline-times bg-gray-300 dark:bg-neutral-900 scroller-follow" :style="transformAmount()">
                    <div v-for="item in everyNminutes(60).slice(1)" :ref="'scroll_' + item"
                        class="timeline-time hour text-xs dark:text-primary"
                        :style="'grid-column: t-' + item + ' / t-' + item + ';'">
                        {{ addColon(item) }}</div>
                </div>
            </div>


            <div v-once class="timelineBlock mb-24 scrollbar-hide border-b border-gray-400 dark:border-neutral-700" id="timelineBlock" @scroll="HandleScroll"
                :class="[$attrs.iframe ? 'min-h-screen' : '']">
                <div v-once class="timeline-lines pointer-events-none" id="timeline">
                    <div v-for="item in everyNminutes(10).slice(1)"
                        class="timeline-line border-r border-gray-200 dark:border-neutral-800"
                        :style="'grid-column: t-' + item + '/ t-' + item + ';'">
                    </div>
                    <div v-for="item in everyNminutes(60).slice(1)"
                        class="timeline-line border-r border-gray-400 dark:border-neutral-600"
                        :style="'grid-column: t-' + item + '/ t-' + item + ';'">
                    </div>
                    <div v-if="isToday()" class="absolute w-[4px] h-full bg-primary z-[10] shadow-xl " ref="timeneedle"
                        id="timeneedle"
                        :style="'grid-column: t-' + moment(time).format('HHmm') + '/ t-' + moment(time).add(3, 'minutes').format('HHmm') + ';'">
                    </div>
                </div>

                <template v-for="(location, index) in data" v-if="location.events && location.events.length > 0">
                    <div class="mx-auto sticky left-0 pb-2">
                        <div
                            class="px-4 flex justify-between sm:justify-start items-center bg-gray-200 dark:bg-neutral-950">
                            <h3 class="text-sm md:text-lg dark:text-white">
                                {{ getTranslated(location.name) }}
                            </h3>
                            <a v-if="promotions.includes(location.id)"
                                :href="($i18n.locale == $i18n.fallbackLocale ? '' : '/' + $i18n.locale + '/') + 'termsandconditions'"
                                target="blank"
                                class="z-[1] text-gray-400 px-2 py-1 flex items-center justify-end hover:text-yellow-500 dark:hover:text-yellow-300  transition cursor-help">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512"
                                    class="w-3 h-3">
                                    <path
                                        d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z">
                                    </path>
                                </svg>
                                <span class="text-xs ml-1 lowercase">{{ $t("sponsored") }}</span>
                            </a>
                        </div>
                    </div>

                    <div class="timeline bigger pb-2">
                        <template v-for="(event, index2) in location.events">
                            <a v-if="(event.event_items.length == 0 && event.event_repeats.length == 0)"
                                :ref="index + '_' + index2" :href="$homeUrl + '/events/' + event.slug"
                                :style="'grid-column: t-' + getStartPos(event) + '/ t-' + getEndPos(event) + ';' + ($attrs.accentcolor ? 'background-color: ' + $attrs.accentcolor + '; color:white !important' : '')"
                                :target="$attrs.iframe ? '_blank' : '_self'"
                                class="js_event_item relative flex items-center snap-start shadow transition cursor-pointer group dark:text-white bg-white dark:bg-neutral-800 hover:bg-gray-200 active:bg-gray-300 dark:hover:bg-neutral-700 dark:active:bg-neutral-600 p-2 rounded-xl active:scale-y-95 active:shadow-none">

                                <div class="flex items-center sticky left-2 event max-w-full z-[1]">
                                    <img v-if="bigEvent(event)" :src="event.image_link"
                                        class="w-12 h-12 object-cover rounded-md pointer-events-none mr-2 group-hover:scale-90 group-active:scale-75 transition shrink-0"
                                        loading="lazy">
                                    <div class="flex flex-col min-w-[100px] max-w-[calc(100%-56px)]">
                                        <span class="h-0 opacity-0 whitespace-nowrap text-sm">
                                            {{ getTranslated(event.name) }}
                                        </span>
                                        <div class="max-w-full overflow-hidden relative h-5">
                                            <span class="scroll_long_text text-sm">
                                                {{ getTranslated(event.name) }}
                                            </span>
                                        </div>
                                        <span :class="[$attrs.accentcolor ? '!text-white' : '']"
                                            class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-primary opacity-70">
                                            {{ getTimeDescription(event) }}
                                        </span>
                                        <div v-if="event.price" class="flex gap-1">
                                            <span v-if="event.price > 0" :class="[event.sold_out ? 'line-through' : '']"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs opacity-70">
                                                €{{ event.price }}
                                            </span>
                                            <span v-else-if="event.price < 0 && event.parent[0]"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs opacity-70">
                                                {{ $t('Event pass') }}
                                            </span>
                                            <span v-else-if="event.price == 0"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-bold">
                                                {{ $t('Free') }}!
                                            </span>
                                            <span v-if="event.sold_out"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-red-500">
                                                {{ $t('Sold out') }}!
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <a v-else-if="event.event_items.length > 0" v-for="(eventItem, index3) in event.event_items"
                                :ref="index + '_' + index2 + '_item_' + index3" :href="$homeUrl + '/events/' + event.slug"
                                :style="'grid-column: t-' + getStartPos(eventItem) + '/ t-' + getEndPos(eventItem) + ';' + ($attrs.accentcolor ? 'background-color: ' + $attrs.accentcolor + '; color:white !important' : '')"
                                :target="$attrs.iframe ? '_blank' : '_self'"
                                class="js_event_item flex items-center snap-start shadow transition cursor-pointer group dark:text-white bg-white dark:bg-neutral-800 hover:bg-gray-200 active:bg-gray-300 dark:hover:bg-neutral-700 dark:active:bg-neutral-600 p-2 rounded-xl">
                                <div class="flex items-center sticky left-2 eventItem max-w-full">
                                    <img v-if="bigEvent(eventItem)" :src="event.image_link"
                                        class="w-12 h-12 object-cover rounded-full pointer-events-none mr-2 group-hover:scale-90 transition shrink-0"
                                        loading="lazy">
                                    <div class="flex flex-col min-w-[100px] max-w-[calc(100%-56px)]">
                                        <span class="h-0 opacity-0 whitespace-nowrap text-sm">
                                            {{ getTranslated(event.name) }}
                                        </span>
                                        <div class="max-w-full overflow-hidden relative h-5">
                                            <span class="scroll_long_text text-sm">
                                                {{ getTranslated(event.name) }}
                                            </span>
                                        </div>
                                        <span v-if="sameday(eventItem)" :class="[$attrs.accentcolor ? '!text-white' : '']"
                                            class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-primary opacity-70ƒ">
                                            {{ getTime(eventItem.start) }} - {{ getTime(eventItem.end) }}
                                        </span>
                                        <span v-else :class="[$attrs.accentcolor ? '!text-white' : '']"
                                            class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-primary opacity-70">
                                            {{ getDate(eventItem.start) }} - {{ getDate(eventItem.end) }}
                                        </span>
                                        <div class="flex gap-1">
                                            <span v-if="eventItem.price > 0"
                                                :class="[eventItem.sold_out ? 'line-through' : '']"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs opacity-70">
                                                €{{ eventItem.price }}
                                            </span>
                                            <span v-else-if="event.price < 0 && event.parent"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs opacity-70">
                                                {{ $t('Event pass') }}
                                            </span>
                                            <span v-else-if="event.price == 0"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-bold">
                                                {{ $t('Free') }}!
                                            </span>
                                            <span v-if="eventItem.sold_out"
                                                class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-red-500">
                                                {{ $t('Sold out') }}!
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <template v-else-if="event.event_repeats.length > 0">
                                <a v-for="(eventRepeat, index3) in event.event_repeats"
                                    v-if="(eventRepeat.repeat === 'weekly' && isMatchingDay(date, eventRepeat.day)) || (eventRepeat.repeat === 'monthly' && isMatchingDate(date, eventRepeat.day))"
                                    :ref="index + '_' + index2 + '_repeat_' + index3"
                                    :href="$homeUrl + '/events/' + event.slug"
                                    :style="'grid-column: t-' + getStartPos(eventRepeat) + '/ t-' + getEndPos(eventRepeat) + ';' + ($attrs.accentcolor ? 'background-color: ' + $attrs.accentcolor + '; color:white !important' : '')"
                                    :target="$attrs.iframe ? '_blank' : '_self'"
                                    class="js_event_item flex items-center snap-start transition cursor-pointer group dark:text-white bg-gray-200 dark:bg-neutral-950 hover:bg-gray-200 active:bg-gray-300 -mt-2 my-1  dark:hover:bg-neutral-700 dark:active:bg-neutral-600 p-1 px-4">
                                    <div class="flex items-center sticky left-4 eventRepeat">
                                        <div class="relative">
                                            <div class="text-sm">
                                                {{ getTranslated(event.name) }}

                                                <span :class="[$attrs.accentcolor ? '!text-white' : '']"
                                                    class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-primary opacity-70">
                                                    {{ getRepeatDescription(event) }}
                                                </span>
                                                <span v-if="event.price > 0"
                                                    :class="[eventRepeat.sold_out ? 'line-through' : '']"
                                                    class="max-w-[160px] sm:max-w-[200px] capitalize text-xs opacity-70">
                                                    €{{ event.price }}
                                                </span>
                                                <span v-else-if="event.price == 0"
                                                    class="max-w-[160px] sm:max-w-[200px] capitalize text-xs opacity-70">
                                                    {{ $t('Free') }}!
                                                </span>
                                                <span v-if="eventRepeat.sold_out"
                                                    class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-red-500">
                                                    {{ $t('Sold out') }}!
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </template>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="mx-2">
                <div class="max-w-xl bg-gray-200 dark:bg-neutral-800 dark:text-white rounded-xl p-6 mx-auto mb-10">
                    <div class="text-2xl md:text-7xl font-bold text-center text-primary mb-5">😭</div>
                    <div class="text-xl md:text-4xl font-bold text-center text-primary mb-3">{{ $t('No events on this day')
                    }}</div>
                    <div class="text-base text-center">{{ $t("Please try another day") }}!</div>
                </div>
            </div>
        </template>
    </div>
</template>


<script>

import HotelDatePicker from "vue-hotel-datepicker";
import moment from "moment";

export default {
    components: {
        HotelDatePicker
    },
    data() {
        return {
            data: JSON.parse(this.$attrs.data) ?? [],
            promotions: JSON.parse(this.$attrs.promotions) ?? [],
            date: moment(this.$attrs.date),
            scrollingAmount: 0,
            interval: null,
            time: new Date(),

            showDatepicker: false,
            selectedDate: '',
        }
    },
    beforeDestroy() {
        // prevent memory leak
        clearInterval(this.interval)
    },
    mounted() {
        this.scrollToElement();

        if (this.mainevent && !this.$attrs.date) {
            this.date = this.mainevent.start;
        }
    },
    created() {
        // update the time every second
        if (this.isToday()) {
            this.interval = setInterval(() => {
                this.time = new Date();
            }, 60000)
        }
    },
    methods: {
        isMatchingDay(date, day) {
            const today = this.getDate(_.clone(date).format('YYYY-MM-DD'));

            // format of today = "Monday 1 January"
            // get only the day from today
            const todayDay = today.split(" ")[0];
            // format of todayDay = "Monday"

            // convert the day to the full name of the day
            const dayName = moment().day(day).format('dddd');
            // format of dayName = "Monday" or "Tuesday" or "Wednesday" or "Thursday" or "Friday" or "Saturday" or "Sunday"
            // check if todayDay is the same as the given day
            return todayDay === dayName;
        },

        isMatchingDate(date, day) {
            const today = this.getDate(date);
            // get only the day from the today
            const todayDay = today.split(" ")[1];

            // check if todayday is the same as the given day
            return todayDay === day;

        },

        getRepeatDescription(event) {
            const dayAbbr = {
                1: this.$t("datepicker")['day-names'][1], // 'ma'
                2: this.$t("datepicker")['day-names'][2], // 'di'
                3: this.$t("datepicker")['day-names'][3], // 'wo'
                4: this.$t("datepicker")['day-names'][4], // 'do'
                5: this.$t("datepicker")['day-names'][5], // 'vr'
                6: this.$t("datepicker")['day-names'][6], // 'za'
                7: this.$t("datepicker")['day-names'][0]  // 'zo'
            };

            const dayFull = {
                1: this.$t('Monday'),   // 'maandag'
                2: this.$t('Tuesday'),  // 'dinsdag'
                3: this.$t('Wednesday'), // 'woensdag'
                4: this.$t('Thursday'),  // 'donderdag'
                5: this.$t('Friday'),    // 'vrijdag'
                6: this.$t('Saturday'),  // 'zaterdag'
                7: this.$t('Sunday')     // 'zondag'
            };

            const returnvalue = [];

            const dayAbbreviations = [];
            const fullDays = [];
            const monthlyRepeats = [];

            event.event_repeats.forEach((eventRepeat) => {
                switch (eventRepeat.repeat) {
                    case 'weekly':
                        const dayAbbreviation = dayAbbr[eventRepeat.day];
                        const dayFullName = dayFull[eventRepeat.day];

                        dayAbbreviations.push(dayAbbreviation);
                        fullDays.push(dayFullName);

                        if (!dayAbbreviations.includes(dayAbbreviation)) {
                            dayAbbreviations.push(dayFullName);
                        }
                        break;
                    case 'monthly':
                        monthlyRepeats.push(`${eventRepeat.day}`);
                        break;
                }
            });

            let sortedDayAbbreviations = Object.keys(dayAbbreviations)
                .sort() // Sorts the keys
                .reduce((acc, key) => {
                    acc[key] = dayAbbreviations[key];
                    return acc;
                }, {});

            let sortedMonthlyRepeats = monthlyRepeats.sort((a, b) => a - b);


            let dayOutput = '';
            if (dayAbbreviations.length > 1) {
                dayOutput = `${this.$t('every')} ${dayAbbreviations.join(', ')}`;
            } else if (dayAbbreviations.length === 1) {
                dayOutput = fullDays[0] || '';
            }

            let monthlyOutput = '';
            if (monthlyRepeats.length > 0) {
                monthlyOutput = `${this.$t('every')} ${monthlyRepeats.join(', ')} ${this.$t('day of the month')}`;
            }

            let output = dayOutput;
            if (monthlyOutput) {
                output += monthlyOutput;
            }

            return output;
        },

        today() {
            return moment(new Date()).format('DDMMYYYY')
        },

        scrollToElement() {
            const el = this.$refs['0_0'];
            const currentTime = this.$refs['timeneedle'];
            if (currentTime && !this.$attrs.iframe) {
                currentTime.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            } else if (el && !this.$attrs.iframe) {
                el[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        },

        getTranslated(n) {
            if (document.documentElement.lang in n) {
                return n[document.documentElement.lang]
            } else {
                return n['en']
            }
        },

        HandleScroll(e) {
            this.scrollingAmount = this.$el.querySelector("#timeline").getBoundingClientRect().left;
        },

        transformAmount() {
            return 'transform: translateX(' + this.scrollingAmount + 'px);';
        },

        getTime(date) {
            var dateTime = this.parseDateTime(_.clone(date));

            // check if the format of the date is a time string (e.g., "09:30:00")
            if (moment(dateTime, 'HH:mm:ss', true).isValid()) {
                return moment.utc(dateTime, 'HH:mm:ss').format('H:mm');
            } else {
                return moment.utc(dateTime).format('H:mm');
            }
        },

        getTimeDescription(event) {
            if (event.repeat) {
                var repeatInfo = event.repeat.split(",");
                var returnVal = []
                repeatInfo.forEach((element) => {
                    var items = element.split("_");
                    switch (items[0]) {
                        case 'WEEKLY':
                            returnVal.push(moment().weekday(parseInt(items[1]) - 1).format('dddd'))
                            break;
                    }
                })
                return this.$t('Every') + ' ' + returnVal.join(', ');
            } else {
                if (this.sameday(event)) {
                    return this.getTime(event.start) + '-' + this.getTime(event.end);
                } else {
                    return this.getDate(event.start) + '-' + this.getDate(event.end)
                }
            }
        },

        sameday(event) {
            if (moment.utc(this.parseDateTime(_.clone(event.start))).format("DDMMYYYY") == moment.utc(this.parseDateTime(_.clone(event.end))).format("DDMMYYYY")) {
                return true;
            } else if (moment.utc(this.parseDateTime(_.clone(event.end))).subtract(10, 'hours').format("DDMMYYYY") == moment.utc(this.parseDateTime(_.clone(event.start))).format("DDMMYYYY")) {
                return true;
            }
            return false
        },

        isToday() {
            return moment(this.$attrs.date).isSame(new Date(), 'day');
        },

        prevDay(date) {
            var dateTime = _.clone(date);
            return moment.utc(dateTime).subtract(1, 'days').format('DDMMYYYY');
        },

        nextDay(date) {
            var dateTime = _.clone(date);
            return moment.utc(dateTime).add(1, 'days').format('DDMMYYYY');
        },
        parseDateTime(value) {
            if (!isNaN(value) && !_.isObject(value)) {
                let timestamp = Number(value);

                // Convert seconds to milliseconds if 10-digit
                if (timestamp.toString().length === 10) {
                    timestamp *= 1000;
                }

                return moment.utc(timestamp);
            }

            if (_.isString(value)) {
                return moment.utc(
                    value,
                    [
                        moment.ISO_8601,
                        'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
                        'YYYY-MM-DDTHH:mm:ss.SSSZ',
                        'YYYY-MM-DD HH:mm:ss',
                        'HH:mm:ss'
                    ],
                    true
                );
            }

            return moment.invalid();
        },

        bigEvent(event) {
            // Parse start and end times with multiple formats using moment.utc()
            const startTime = this.parseDateTime(_.clone(event.start));
            const endTime = this.parseDateTime(_.clone(event.end));

            // Check if the parsed dates are valid and calculate the difference
            if (startTime.isValid() && endTime.isValid()) {
                // Calculate the difference in milliseconds
                const duration = endTime.diff(startTime);

                // Check if the event duration is 1 hour (3600000 milliseconds) or longer
                return duration >= 1800000;
            }

            return false;
        },

        getStartPos(event) {
            console.log(event.start);
            const dateTime = this.parseDateTime(_.clone(event.start));
            console.log(dateTime);
            var today = _.clone(this.date).utc();
            var tomorrow = moment.utc(_.clone(this.date), ['YYYY-MM-DDTHH:mm:ss.SSSSSSZ'], true).add(1, 'days').utc();

            console.log(dateTime);
            if (today.format("DDMMYYYY") === dateTime.format("DDMMYYYY") && dateTime.isValid()) {
                return dateTime.format("HHmm");
            } else if (tomorrow.format("DDMMYYYY") === dateTime.format("DDMMYYYY") && dateTime.isValid()) {
                return parseInt(dateTime.format("HHmm")) + 2400;
            } else {
                return "0000";
            }
        },

        getEndPos(event) {
            const startTime = this.parseDateTime(_.clone(event.start));
            const endTime = this.parseDateTime(_.clone(event.end));

            const today = moment.utc(_.clone(this.date));
            const tomorrow = moment.utc(_.clone(this.date)).add(1, 'days');

            if (today.format("DDMMYYYY") === endTime.format("DDMMYYYY") && endTime.isValid()) {
                const duration = endTime.diff(startTime, 'minutes');

                if (duration < 45) {
                    return startTime.clone().add(45, 'minutes').format("HHmm");
                } else {
                    return endTime.clone().subtract(1, 'minute').format("HHmm");
                }
            } else if (tomorrow.format("DDMMYYYY") === endTime.format("DDMMYYYY") && endTime.isValid()) {
                if (endTime.format('HHmm') === '0000') {
                    return "2400";
                }

                const duration = endTime.diff(startTime, 'minutes');
                let time;
                if (duration < 45) {
                    time = startTime.clone().add(45, 'minutes').format("HHmm");
                } else {
                    time = endTime.clone().subtract(1, 'minute').format("HHmm");
                }

                time = parseInt(time, 10) + 2400;
                return time.toString();
            } else {
                return "2859";
            }
        },


        everyNminutes(n) {
            var result = [];
            for (var hours = 0; hours < 28; hours++) {
                for (var minutes = 0; minutes < 60; minutes = minutes + n) {
                    var h = '';
                    var m = '';
                    h = ("0" + hours).slice(-2)
                    m = ("0" + minutes).slice(-2)

                    result.push(h + '' + m);
                }
            }
            return result;
        },

        addColon(n) {
            if (n >= 2400) {
                return n.slice(0, 2) - 24 + ':' + n.slice(2);
            } else {
                return n.slice(0, 2) + ':' + n.slice(2);
            }
        },

        textShorter(text) {
            if (text.length > 30) {
                return text.substring(0, 30) + ' ...';
            }
            return text;
        },

        toggleDatepicker() {
            this.showDatepicker = !this.showDatepicker;
        },

        handleDayClick(event, checkinDate) {
            console.log(checkinDate);

            this.date = moment(checkinDate);

            this.DatePicker = false;
            // Redirect to the new date
            const newUrl = this.$attrs.mainevent
                ? `?eventsdate=${this.date.format('DDMMYYYY')}&event=${JSON.parse(this.$attrs.mainevent).slug}`
                : `?eventsdate=${this.date.format('DDMMYYYY')}`;

            window.location.href = newUrl;
        },

        closeDatepicker() {
            this.showDatepicker = false; // Close the datepicker
        },

        getHeaderDate(date) {
            var dateTime = _.clone(date);
            return moment.utc(dateTime).format('dddd D MMMM');  // Monday 1 January
        },

        getDate(date) {
            console.log(date);
            const dateTime = this.parseDateTime(_.clone(date));

            console.log(dateTime);
            if (!dateTime.isValid()) {
                console.error('Invalid date in getDate:', date);
                return 'Invalid Date';
            }

            // Check if it's a time-only string
            if (_.isString(date) && /^\d{2}:\d{2}:\d{2}$/.test(date)) {
                return dateTime.format('HH:mm:ss');
            }

            return dateTime.format('dddd D MMMM');
        },

    },
}




</script>

